<template lang='pug'>
  div
    // TODO: Width is not auto when text is short, fix
    v-dialog.message-close-dialog(v-model='isDialogOpen' max-width='300')
      v-card
        v-card-title.h6-material.quickytools-font {{dialogTitle}}
        v-card-text.pre-line(v-if='dialogMessage') {{dialogMessage}}
        v-card-text.pre-line(v-else-if='htmlDialogMessage')
          span(v-html="htmlDialogMessage")
        v-card-actions(v-if='positiveActionText||negativeActionText')
          v-spacer
          v-btn(outlined color='accent' v-if='negativeActionText' @click.native='onActionPress(-1)') {{negativeActionText}}
          v-btn(outlined color='accent' v-if='positiveActionText' @click.native='onActionPress(1)') {{positiveActionText}}
</template>

<script>
import commonResource from '@/resources/common'

// TODO Write audit on pre deploy that fails on unapproved links/html

export default {
  name: 'TitleMessageActionDialog',
  data: () => ({
    // Event names
    dialogActionEventName: 'dialog-action',
    // Set to identify the reason dialog was presented, is passed back on dialog action
    presentId: null,
    // Visibility toggle of the dialog
    isDialogOpen: false,
    // Content
    dialogTitle: '',
    dialogMessage: '',
    htmlDialogMessage: '',
    positiveActionText: '',
    negativeActionText: ''
  }),
  watch: {
    isDialogOpen (val) {
      if (!val) {
        this.$emit('on-close')
      }
    }
  },
  methods: {
    // Shows a message and OK action
    showMessageOkDialog: function (message) {
      this.showDialog('', message, commonResource.ok)
    },
    // Shows title and message with close action
    showCloseDialog: function (title, message) {
      this.showDialog(title, message, commonResource.close)
    },
    showDialogProperties ({
      title,
      message,
      positiveAction,
      negativeAction,
      id,
      isHtmlMessage
    }) {
      this.showDialog(title, message, positiveAction, negativeAction, id, isHtmlMessage)
    },
    // Fully customizable dialog
    showDialog: function (
      title,
      message,
      positiveActionText = '',
      negativeActionText = '',
      presentId = null,
      isHtmlMessage = false
    ) {
      this.dialogTitle = title
      this.dialogMessage = isHtmlMessage ? '' : message
      this.htmlDialogMessage = isHtmlMessage ? message : ''
      this.positiveActionText = positiveActionText
      this.negativeActionText = negativeActionText
      this.presentId = presentId
      this.isDialogOpen = true
    },
    /*
     * Internal callback when action is pressed
     * actionKey is defined in HTML (should be -1 for negative action and 1 for positive)
     */
    onActionPress: function (actionKey) {
      this.isDialogOpen = false
      this.$emit(this.dialogActionEventName, {
        action: actionKey,
        id: this.presentId
      })
    },
    // Subscribes to on action press
    subscribeOnAction: function (cb) {
      this.$on(this.dialogActionEventName, cb)
    }
  }
}
</script>

<style lang="scss" scoped>
.pre-line {
  white-space: pre-line;
}
</style>
